<template>
  <div class="icone">
    <div class="opcao" @click="showUF = !showUF">
      <button>
        <img src="@/assets/vivo-consulta/icones/icone-local.svg" alt="Pin" />
      </button>
      <span>{{ userUF }}</span>
    </div>
    <div class="menu" v-if="showUF">
      <ul>
        <li v-for="(item, idx) in uf" :key="idx" :class="ufActive(item)">
          <a @click="selectUF(item)">{{ item }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'SelecioneUF',

  data() {
    return {
      uf: [
        'AC',
        'AL',
        'AP',
        'AM',
        'BA',
        'CE',
        'DF',
        'ES',
        'GO',
        'MA',
        'MT',
        'MS',
        'MG',
        'PA',
        'PB',
        'PR',
        'PE',
        'PI',
        'RJ',
        'RN',
        'RS',
        'RO',
        'RR',
        'SC',
        'SP',
        'SE',
        'TO',
      ],
      showUF: false,
    };
  },
  computed: {
    ...mapGetters({
      userUF: 'vcUser/uf',
    }),
  },
  methods: {
    ...mapActions({
      changeUF: 'vcUser/changeUF',
    }),
    ufActive(uf) {
      return uf === this.userUF ? 'active' : null;
    },
    async selectUF(uf) {
      this.showUF = false;
      await this.changeUF(uf);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.icone {
  position: relative;
  .opcao {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease-in-out;
    cursor: pointer;

    & span {
      margin-left: 10px;
      color: #fff;
    }

    & button {
      padding: 0px;
      padding-left: 20px;

      & img {
        max-width: 20px;
      }
    }

    & a {
      margin: 0px;
      padding: 0px;
      padding-left: 5px;
    }

    &:hover {
      transform: scale(1.05);

      & > a {
        color: white;
      }
    }
  }

  & .menu {
    position: absolute;
    top: 40px;
    right: -15px;
    display: flex;
    width: 220px;
    background: #660099;
    border-radius: 5px;
    border: 1px solid rgba(white, 0.3);
    box-shadow: 0px 2px 15px 0px rgba(black, 0.6);
    animation: abrir 0.2s 1 ease-in-out;
    z-index: 100;
    & > ul {
      padding: 5px 10px;
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-direction: row;
      flex-wrap: wrap;
      & li {
        padding: 5px;
        width: 40px;
        text-align: center;
        & a {
          color: #fff;
          font-weight: 500;
          transition: all 0.3s ease-in-out;
          &:hover {
            color: $cor_amarelo;
            font-weight: bold;
            text-shadow: 0px 20px 15px 0px rgba(black, 0.4);
          }
        }
      }
      & li.active {
        background: $cor_amarelo;
        border-radius: 5px;
        & a {
          color: #609;
          font-weight: bold;
        }
      }
    }
  }
}

@keyframes abrir {
  0% {
    opacity: 0;
    margin-top: -30px;
  }
  100% {
    opacity: 1;
    margin-top: 0px;
  }
}

button {
  cursor: pointer;
  user-select: none;
  background: transparent;
  border: 0px;
  outline: none;
}

@media all and (min-width: 300px) and (max-width: 1160px) {
}
</style>
